import { FormState } from "./FormState";
import { crearServicioSpa, NuevoServicioSpa } from "../../../services/spaServicios";
import { parseCurrency } from "../../../utils/numberUtils";

const generarNuevoServicioSpa = (formState: FormState): NuevoServicioSpa => {
    return {
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.wasTouched ? formState.descripcion.value : undefined,
        precioSesion: parseCurrency(formState.precioSesion.value, "$", ",")
    }
}

export const crearNuevoServicioSpa = async (formState: FormState) => {
    const nuevoServicio = generarNuevoServicioSpa(formState);
    await crearServicioSpa(nuevoServicio);
}